module.exports = __webpack_public_path__ + "static/media/Notifications.9a3aa721.md";